<dashboardnav>
  
    <cradua-incidentcategory
        [incidentcategorys]="incidentcategorys$ | async"
        (incidentcategory)="onSubmitIncidentCategory($event)"
        (deleteIncidentCategoryEvent)="onDeleteIncidentCategory($event)"
        *ngIf="(isLoading$ | async ) === false"
        >
  </cradua-incidentcategory>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  